<template>
  <!-- 右侧矩形广告 -->
  <div class="right-box" v-if="right_adv.url">
    <div class="rightTop">
      <img
        width="100%"
        :src="right_adv.image"
        alt=""
        @click="rightAdvClick(right_adv.param, right_adv.url)"
      />
      <span>广告</span>
    </div>
  </div>
</template>
<script>
import { getone, advclick } from "@/api/adv";
export default {
  props: {
    keys: {
      type: [String, Number], //可指定接收类型，如:Array.
      default: "" //可设置默认值
    },
    advId: {
      type: [String, Number],
      default: 651
    }
  },
  data() {
    return {
      //右侧广告
      right_adv: {
        image: "",
        url: "",
        param: ""
      }
    };
  },
  methods: {
    rightAdvClick(data, url) {
      this.$parent.rightAdvClick(data, url);
    }
  },
  created() {
    //右侧广告
    getone(this.advId, this.keys).then(res => {
      if (res != "" && res.data != "" && res.data.return_code == 0) {
        try {
          if (res.data.direct_creatives_info[0].adsold) {
            this.right_adv.url = res.data.direct_creatives_info[0].click_url;
            var img = res.data.direct_creatives_info[0].user_define_content;
            img = JSON.parse(img);
            this.right_adv.image = img.imgUrl;
            this.right_adv.param = res.data.direct_creatives_info[0];
          }
        } catch (error) {}
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.rightTop {
  position: relative;
  width: 320px;
  height: 250px;
  background: #fff;
  margin: 30px 0;
  span {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 12px;
    color: #fff;
    background: #33333380;
    line-height: 20px;
    padding: 0 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightadv.vue